/** @format */

import { getResourceCode } from "../../utils/GetResourceCode";
import { Locale } from "../i18n/init";
import { Resource } from "../resources/types";

export function getRFBaseURL(currentURL: string): {
  url: string;
  locale?: Locale;
} {
  switch (currentURL) {
    // LOCAL
    case "localhost":
      return {
        url:
          process.env.REACT_APP_RESOURCES_FILTER_URL ??
          "https://d6uuxnjh1ac7h.cloudfront.net",
        locale: undefined, // this is undefined because the env var has a trailing locale.
      };

    // DEV OLD
    case "d248ng6lah0yhh.cloudfront.net":
      return { url: "https://dqh7anrc2vq6j.cloudfront.net", locale: "en" };

    // DEV NEW
    case "bl.dev.resources.wjec.co.uk":
      return { url: "https://filter.dev.resources.wjec.co.uk", locale: "en" };

    // STAGING OLD
    case "djyliz36h1jc0.cloudfront.net":
      return { url: "https://d6uuxnjh1ac7h.cloudfront.net", locale: "en" };

    // STAGING NEW
    case "bl.staging.resources.wjec.co.uk":
      return {
        url: "https://filter.staging.resources.wjec.co.uk",
        locale: "en",
      };

    // PROD
    case "blended-learning.resources.wjec.co.uk":
      return {
        url: "https://filter.resources.wjec.co.uk",
        locale: "en",
      };
    case "dysgu-cyfunol.adnoddau.cbac.co.uk":
      return {
        url: "https://hidlydd.adnoddau.cbac.co.uk",
        locale: "cy",
      };

    default:
      return {
        url: "https://filter.resources.wjec.co.uk",
        locale: "en",
      };
  }
}

export function getRefLink(resource: Resource): string {
  const baseUrl = getRFBaseURL(document.location.hostname);
  return `${baseUrl.url}/${baseUrl.locale ?? "en"}/s/${resource.Subject.title[baseUrl.locale ?? "en"]}/r/${getResourceCode(resource)}/BL/${resource.Qualification.toUpperCase()}`;
}
